var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-center"},[_c('v-snackbar',{class:_vm.classList,attrs:{"timeout":_vm.timeout,"top":"top","right":"right"},model:{value:(_vm.snackbar),callback:function ($$v) {_vm.snackbar=$$v},expression:"snackbar"}},[_vm._v(" "+_vm._s(_vm.snackMessage)+" ")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }